<template>
    <h1 class="job-page__title">{{ title }}</h1>
</template>

<script setup lang="ts">
    import {computed, inject} from 'vue';
    import {useTranslation, useRoute} from '#imports';
    import {JOB_PAGE} from '~/keys';

    const {t} = useTranslation();
    const route = useRoute();

    const jobPage = inject(JOB_PAGE);
    const jobLabel = jobPage?.landingPage?.textualContent.thisPage.jobLabel;
    const location = jobPage?.landingPage?.location;

    const {subCategoryId, subCategoryIdOrCityId, categoryId, categoryIdOrCityId, familyId, familyIdOrCityId} = route.params;
    const isSubcategoryPage = subCategoryId || subCategoryIdOrCityId;
    const isCategoryPage = categoryId || categoryIdOrCityId;
    const isFamilyPage = familyId || familyIdOrCityId;
    const isNoFamily = !isFamilyPage;

    const title = computed(() => {
        if (location) {
            if (!isSubcategoryPage && !isCategoryPage && !isFamilyPage) {
                return t('landing.acquisition.city.main.title.localized.short', [location.label]);
            }
            if (isNoFamily) {
                return t('landing.acquisition.main.title.localized.short.no.family', [jobLabel, location.label]);
            }
            return t('landing.acquisition.main.title.localized.short', [jobLabel, location.label]);
        }
        return t('landing.acquisition.main.title.short', [jobLabel]);
    });
</script>

<style lang="scss">
    @use '@malt/joy-entrypoint/src/sass/base/2_mixins/media-queries/media-queries' as mq;

    .job-page__title {
        font-family: var(--joy-font-family-title);
        font-weight: var(--joy-font-weight-normal);
        line-height: var(--joy-line-height-small);
        margin-bottom: var(--joy-core-spacing-6);

        font-size: var(--joy-font-size-secondary-400);

        @include mq.screen_md(min) {
            font-size: var(--joy-font-size-secondary-800);
        }
    }
</style>
